import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const ErrorColors = createInteractiveColorVars('error');
const ErrorColorsLightValues = Object.freeze({
    base: {
        default: '#D31E2A',
        action: '#9D0007',
        active: '#D31E2A',
        activeAction: '#9D0007',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const ErrorColorsDarkValues = Object.freeze({
    base: {
        default: '#F8495A',
        action: '#A62332',
        active: '#F8495A',
        activeAction: '#A62332',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { ErrorColors, ErrorColorsDarkValues, ErrorColorsLightValues };
